const r = {
  SkipError: "skipError"
};
export {
  r as ApiContextOptions
};
//# sourceMappingURL=apollo.js.map
